<!--request section start-->
<a (click)="openVerticallyCentered(content)" class="btn btn-default btn-gradient text-white button-sound">{{'REQUEST.Link' | translate}}</a>
<ng-template #content let-modal>
    <div class="modal-window">
        <div class="modal-header">
            <button aria-label="Close" class="close" data-dismiss="modal" type="button"
                (click)="closeModalWindow(stepper)">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <h2 class="audit">{{auditText}}</h2>
            <mat-horizontal-stepper #stepper>
                <ng-template matStepperIcon="edit">
                    <mat-icon>done_outline</mat-icon>
                </ng-template>
                <mat-step [stepControl]="firstFormGroup">
                    <form [formGroup]="firstFormGroup">
                        <ng-template matStepLabel>
                            {{nameFirstStep}}
                        </ng-template>
                        <div class="container">
                            <div class="row">
                                <div class="col-md-6 p-l-0">
                                    <div class="m-b-25">
                                        <mat-form-field class="customize-input">
                                            <mat-label>{{'REQUEST.Name.head' | translate}} <span class="text-danger">*</span>
                                            </mat-label>
                                            <input matInput type="text" formControlName="nameCtrl"
                                                placeholder="{{'REQUEST.Name.placeholder' | translate}}" autocomplete="off">
                                            <mat-icon class="font-primary" matSuffix>perm_identity
                                            </mat-icon>
                                            <mat-error *ngIf="firstFormGroup.controls['nameCtrl'].errors">
                                                {{'REQUEST.Name.error.1' | translate}}
                                                <strong>{{'REQUEST.Name.error.2' | translate}}</strong>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="m-b-25">
                                        <mat-form-field class="customize-input">
                                            <mat-label>{{'REQUEST.Email.head' | translate}} <span class="text-danger">*</span>
                                            </mat-label>
                                            <input matInput formControlName="emailCtrl" type="email"
                                                placeholder="{{'REQUEST.Email.placeholder' | translate}}" autocomplete="off">
                                            <mat-icon class="font-primary" matSuffix>alternate_email
                                            </mat-icon>
                                            <mat-error *ngIf="firstFormGroup.controls['emailCtrl'].errors">
                                                {{'REQUEST.Email.error.1' | translate}}<strong>
                                                    {{'REQUEST.Email.error.2' | translate}}</strong>
                                                    {{'REQUEST.Email.error.3' | translate}}
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="m-b-25">
                                        <mat-form-field class="customize-input">
                                            <mat-label>{{'REQUEST.Additional information.head' | translate}}
                                            </mat-label>
                                            <textarea matInput formControlName="aboutCtrl" #aboutCtrl
                                                placeholder="{{'REQUEST.Additional information.placeholder' | translate}}" maxlength="500"
                                                rows="5"></textarea>
                                            <mat-error *ngIf="firstFormGroup.controls['aboutCtrl'].errors">
                                                {{'REQUEST.Additional information.error.1' | translate}}<strong>
                                                    {{'REQUEST.Additional information.error.2' | translate}}</strong>
                                            </mat-error>
                                            <mat-hint align="end">
                                                {{aboutCtrl.value.length}} /
                                                <strong>500</strong>
                                            </mat-hint>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-md-6 p-r-0">
                                    <div class="m-b-25">
                                        <mat-form-field class="customize-input">
                                            <mat-label>{{'REQUEST.Name Company.head' | translate}} <span class="text-danger">*</span>
                                            </mat-label>
                                            <input matInput type="text" formControlName="companyCtrl"
                                                placeholder="{{'REQUEST.Name Company.placeholder' | translate}}" autocomplete="off">
                                            <mat-icon class="font-primary" matSuffix>business
                                            </mat-icon>
                                            <mat-error *ngIf="firstFormGroup.controls['companyCtrl'].errors">
                                                {{'REQUEST.Name Company.error.1' | translate}}
                                                <strong>{{'REQUEST.Name Company.error.2' | translate}}</strong>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="m-b-25">
                                        <mat-form-field class="customize-input">
                                            <mat-label>{{'REQUEST.Phone number.head' | translate}} <span class="text-danger">*</span>
                                            </mat-label>
                                            <input matInput formControlName="phoneCtrl" type="tel"
                                                placeholder="{{'REQUEST.Phone number.placeholder' | translate}}" autocomplete="off">
                                            <mat-icon class="font-primary" matSuffix>phone
                                            </mat-icon>
                                            <mat-error *ngIf="firstFormGroup.controls['phoneCtrl'].errors">
                                                {{'REQUEST.Phone number.error.1' | translate}} <strong>
                                                    {{'REQUEST.Phone number.error.2' | translate}}</strong>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="m-b-20">
                                        <mat-form-field class="customize-input">
                                            <mat-label>{{'REQUEST.Skype.head' | translate}}</mat-label>
                                            <input matInput type="text" formControlName="skypeCtrl" autocomplete="off"
                                                placeholder="{{'REQUEST.Skype.placeholder' | translate}}">
                                            <mat-icon class="font-primary" matSuffix>voice_chat
                                            </mat-icon>
                                        </mat-form-field>
                                    </div>
                                    <div class="d-flex justify-content-end align-items-center">
                                        <button class="btn btn-default btn-gradient text-white reset-button-style"
                                            [disabled]="firstFormGroup.invalid" (click)="sendRequest(stepper)">
                                            {{'REQUEST.Send Request' | translate}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </form>
                </mat-step>
                <mat-step>
                    <ng-template matStepLabel>
                        {{'REQUEST.Done.header' | translate}}
                    </ng-template>
                    <h3 class="text-center fw800 m-t-10">
                        {{'REQUEST.Done.result' | translate}}
                    </h3>
                    <h3 class="text-center fw800 m-t-10 m-b-30">
                        {{'REQUEST.Done.message' | translate}}
                    </h3>
                    <div class="agency container">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="side-img left-0 top-0" *ngIf="turnAnimation == true"
                                    [@fadeInLeft]="fadeInLeft">
                                    <div class="plus-container plus-container6">
                                        <div class="plus">
                                        </div>
                                    </div>
                                    <div class="plus-container plus-container8">
                                        <div class="plus plus plus-small">
                                        </div>
                                    </div>
                                    <div class="plus-container plus-container9">
                                        <div class="plus">
                                        </div>
                                    </div>
                                    <div class="plus-container plus-container10">
                                        <div class="plus plus-medium">
                                        </div>
                                    </div>
                                    <div class="plus-container plus-container11">
                                        <div class="plus plus plus-small">
                                        </div>
                                    </div>
                                    <img src="assets/images/agency/header/image.png" alt="Request Done Animation Left"
                                        class="img-fluid about-img" loading="lazy">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="side-img left-0 top-0" *ngIf="turnAnimation == true"
                                    [@fadeInRight]="fadeInRight">
                                    <div class="plus-container plus-container6">
                                        <div class="plus">
                                        </div>
                                    </div>
                                    <div class="plus-container plus-container8">
                                        <div class="plus plus plus-small">
                                        </div>
                                    </div>
                                    <div class="plus-container plus-container9">
                                        <div class="plus">
                                        </div>
                                    </div>
                                    <div class="plus-container plus-container10">
                                        <div class="plus plus-medium">
                                        </div>
                                    </div>
                                    <div class="plus-container plus-container11">
                                        <div class="plus plus plus-small">
                                        </div>
                                    </div>
                                    <img src="assets/images/agency/header/image1.png" alt="Request Done Animation Right"
                                        class="img-fluid about-img" loading="lazy">
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-step>
            </mat-horizontal-stepper>
        </div>
    </div>
</ng-template>
<!--request section end-->